
import { Row, Col, Input, Form, Button } from 'antd'

import React from 'react'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import './CompareDialog.css'


function DuplicateBPIDDialog({ show, handleCancel, goToProject, onClickOk }) {
  
    return (
        <>
            <Modal className='centered-title-modal' show={show} onHide={handleCancel} centered>
                <Modal.Header  closeButton style={{ fontSize: 16,}}>
                   Duplicate BPID
                </Modal.Header>
                <Modal.Body>
                    <p>A record already exists with this BPID in the Checklist. Please go to the <a onClick={goToProject}  style={{color: '#1890ff', textDecoration: 'underline'}}>Station Name</a> project to start or edit this Project.</p>
                </Modal.Body>
                <div className="footer-centered-content">
                    <Button type='primary' id="cancelButton" onClick={onClickOk}>OK</Button>
                </div>
            </Modal>
        </>
    )
}

export default DuplicateBPIDDialog            